// Home.jsx

// import logo from './transparentLogo.png';

function Home() {
  return (
    <>


<div className="welcomeheader">
        <h2>welcome to purepostage!
        </h2>
      </div>


<div class="row">

  <div class="column">
<p> A new kind of shipping platform designed to make online shopping more eco-friendly and less stressful for small business owners. 
          While the full platform is still in development, we're currently inviting early partners to join our beta program to test an MVP version, and offer feedback on core features such as label generation and environmental tracking.          </p>


  </div>


  <div class="column">
                <p>This is just the beginning, and we’d love your input as we build something better <strong>together.</strong> </p>

    <p>Follow along on Instagram! @purepostage</p>

  </div>
</div>
    </>
  );
}

export default Home;
